<div>
  <div class="col-md-12 col-lg-12">
    <div class="col-sm-3">
      <h4><b>{{ "common.invoiceItems" | translate }}</b></h4>
    </div>
  </div>
</div>
<div class="col-md-12 col-lg-12">
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th>{{ "common.description" | translate }}</th>
        <th>{{ "common.quantity" | translate }}</th>
        <th>{{ "common.unitType" | translate }}</th>
        <th>{{ "common.unitPrice" | translate }}</th>
        <th>{{ "common.harmonizedValue" | translate }}</th>
        <th>{{ "common.ref" | translate }}</th>
        <th>{{ "common.manufacturingCountry" | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of shipmentItems; index as i">
        <td>
          <div>
            <div class="row" *ngIf="openIndex != i">
              <div class="col-md-1">
                <i class="armx-icon  armx-edit" (click)="editShipment(i)"></i>
              </div>
              <div class="col-md-1">
                <i *ngIf="i>=0" (click)="deleteShipment(i)" class="armx-icon armx-trash"></i>
              </div>
            </div>
          </div>
        </td>
        <td>
          <span *ngIf="openIndex != i">{{item.desc}}</span>
          <input (click)="$event.target.select()" *ngIf="openIndex == i" class="form-control" name="Description-{{i}}"
            type="text" [(ngModel)]="item.desc" />
        </td>
        <td>
          <span *ngIf="openIndex != i">{{item.quntity}}</span>
          <input (click)="$event.target.select()" *ngIf="openIndex == i" class="form-control" name="Quntity-{{i}}"
            type="number" [(ngModel)]="item.quntity" min="0" />
        </td>
        <td>
          <span *ngIf="openIndex != i">{{item.unitType}}</span>
          <input (click)="$event.target.select()" *ngIf="openIndex == i" class="form-control" name="Unit-Type-{{i}}"
            type="text" [(ngModel)]="item.unitType" />
        </td>
        <td>
          <span *ngIf="openIndex != i">{{fixDecimals(item.unitPrice)}}</span>
          <input (click)="$event.target.select()" *ngIf="openIndex == i" class="form-control" name="Unit-Price-{{i}}"
            type="number" [(ngModel)]="item.unitPrice" />
        </td>
        <td>
          <span *ngIf="openIndex != i">{{item.hrmValue}}</span>
          <input (click)="$event.target.select()" *ngIf="openIndex == i" class="form-control" name="harmonized-{{i}}"
            type="text" [(ngModel)]="item.hrmValue" />
        </td>
        <td>
          <span *ngIf="openIndex != i">{{item.ref}}</span>
          <input (click)="$event.target.select()" *ngIf="openIndex == i" class="form-control" name="reference-{{i}}"
            type="text" [(ngModel)]="item.ref" />
        </td>
        <td colspan="2">
          <span *ngIf="openIndex != i">{{item.mfCountry}}</span>
          <div *ngIf="openIndex == i">
            <ng-select [items]="countries" bindLabel="key" bindValue="key" [(ngModel)]="item.mfCountry"
              (blur)="onBlurClick()">
            </ng-select>
          </div>
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td><b>{{getTotal().totalPrice}}</b></td>
      </tr>
    </tbody>
  </table>
  <div class="armx-btn-group">
    <button class="btn btn-default" (click)="addNewShipmentItem()">{{ "common.add" | translate }}</button>
  </div>
</div>